import { FC } from 'react'

import { ISvgClass } from '../interface'

const ElipseIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      {...props}
    >
      <circle cx="5" cy="5" r="5" fill="inherit" />
    </svg>
  )
}

export default ElipseIcon
